import Section, {html, css} from './_section'
import { BgdCheck } from '../../ref'
import 'bui/components/metadata'
import 'bui/elements/hr'

const CERTS = ['First Aid/CPR', 'RN', 'BLS', 'WFR', 'Paramedic', 'ACLS', 'ATC', 'CDL', 'ODE School Bus', 'Food Handler Card']

customElements.define('steens-form-background', class extends Section{

    get title(){ return '🗂 Background' }

    static get styles(){return [super.styles, css`
        b-metadata {
            --fc-label-font-family: var(--font-header);
        }
    `]}


    renderControls(){return html`
        <b-grid cols-mobile=1>

            <b-grid cols=4 cols-mobile=2 colspan>
                <b-text colspan>Please list any certifications and professional licenses and their expiration date.</b-text>

                <b-metadata .model=${this.model}
                    .save=${false}
                    attr="certs" 
                    custom="Other"
                    add="Add Certification"
                    .values=${CERTS}
                    .opts=${{
                        placeholder: 'expr. date',
                        formatLabel(key){ return key.toUpperCase() }
                    }}
                ></b-metadata>

                <b-text italic muted=2 colspan sm>You will be asked to send updated hard copy for our records.</b-text>
            </b-grid>

            <div colspan>
                <b-hr thick short></b-hr>
            </div>

            <form-control key="employer" material="filled" label="Employer">
                <input slot="control" autocomplete="section-employer organization">
            </form-control>

            <form-control key="employer_contact" material="filled" label="Employer Contact">
                <input slot="control" autocomplete="section-employer">
            </form-control>

            <form-control key="employer_phone" material="filled" label="Employer Phone">
                <input slot="control" type="tel" autocomplete="section-employer tel">
            </form-control>

            <form-control key="bgd_check" material="filled" label="Background Check on File?">
                <select-field .options=${BgdCheck}></select-field>
                <b-text slot="help">If no, do we have permission to conduct one?</b-text>
            </form-control>

        </b-grid>

    `}

})